/**
 * Function used to get the mask used to bypass a blurred background screen
 * @param
 * @returns
 */
export const getMask = ({
  type,
  x,
  y,
  radius,
  width,
  height,
  borderRadius = 20,
}: {
  type: "circle" | "rect" | "ellipse";
  x: number;
  y: number;
  radius?: number;
  width?: number;
  height?: number;
  borderRadius?: number;
}) => {
  if (type === "circle") {
    return `radial-gradient(circle ${radius}px at ${x}px ${y}px, transparent 100%, black 100%)`;
  } else if (type === "rect") {
    return `url("data:image/svg+xml,${encodeURIComponent(`
      <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <mask id="hole">
            <!-- White background shows the blur everywhere -->
            <rect width="100%" height="100%" fill="white"/>

            <!-- Black rectangle creates the clear viewport -->
            <rect 
              x="${x}" 
              y="${y}" 
              width="${width}" 
              height="${height}" 
              rx="${borderRadius}"
              ry="${borderRadius}"
              fill="black"
            />
          </mask>
        </defs>

        <!-- Apply the mask to a full-screen rectangle -->
        <rect width="100%" height="100%" mask="url(#hole)"/>
      </svg>
    `)}`;
  } else if (type === "ellipse") {
    return `radial-gradient(ellipse ${radius}px at ${x}px ${y}px, transparent 100%, black 100%)`;
  } else return "";
};
